import { connect } from 'react-redux';
import Chat from '../../components/lk/Chat';
import * as actions from '../../actions/lk';

const mapStateToProps = ({ lk, auth }) => ({
  user: lk.data,
  chat: lk.chat,
  messages: lk.messages,
  isLoading: lk.isLoading,
  treeMessages: lk.treeMessages,
  mid: auth.mid,
  photos: lk.photos,
});

const mapDispatchToProps = dispatch => ({
  loadChatInfo: (chatId, toId) => dispatch(actions.loadChatInfo(chatId, toId)),
  lk: () => dispatch(actions.lk()),
  loadMessages: chatId => dispatch(actions.loadMessages(chatId)),
  sendMessage: (message, chatId, parentId, messageId) =>
    dispatch(actions.sendMessage(message, chatId, parentId, messageId)),
  deleteMessage: (chatId, messageId) => dispatch(actions.deleteMessage(chatId, messageId)),
  deleteChat: chatId => dispatch(actions.deleteChat(chatId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
